import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";
import SelectingWarrentImg from '../../../../../components/common/SelectingWarrentImg';



const HowPutWarrantWorks = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("")

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='capital_outlay Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>How a Call Warrant works</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>What are Warrants?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>How a Put Warrant works</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>How are Warrants named</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                                        {/*<link rel="stylesheet" href="css/common.css"/>*/}
                                        <title>How a Put Warrant works?</title>
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .imgholder img{\n                max-width: 735px; \n/*                max-height: 186px; */\n            }\n            p.disclaimer{\n                color:red;\n                font-size:0.8em;\n            }\n                   .contentbox        table{\n                margin: 0 auto;\n            }\n            .contentbox table tbody td{\n               height:3em;\n               width:30%;\n               color:#000000;\n            }\n            .contentbox table tbody td.col1{\n                background-color: #FFF4D2;\n                text-align:left;\n                padding-left: 1em;\n            }\n            .contentbox table tbody td.col2{\n                background-color: #FFFF80;\n                text-align:center;\n            }\n            .contentbox table tbody td.col3{\n                background-color: #FFD400;\n                text-align:center;\n            }\n            .contentbox table tfoot td.disclaimer{\n                padding-top: 0.5em;\n                color: #FFFFFF;\n                font-size: 0.8em;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>If you want to profit from downward movements or are fearful of losses on your existing portfolio
                                                from short-term corrections, put warrants may be the instrument you are looking for.<br /><br />
                                                In our example below using a put warrant over Share A, you can see that the put warrant,
                                                denoted by the yellow line, moves in inverse directions with the Share A which is denoted by the
                                                dotted line.<br /><br />
                                                If you have a view that the Share A had moved too high within a short space of time and due to
                                                fall, you could purchase a put warrant on Share A to profit from your view.</p>
                                            <div className="imgholder">

                                                <img src='/img/education/howaputwarrantworks.png' alt="image" />
                                                <div className="map_pop">
                                                    <div
                                                        className='how_put'
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() =>{ return setOpenLive(true), setImageUrl("/img/education/howaputwarrantworksMob.png")}}
                                                    >View Chart
                                                    </div>
                                                </div>
                                            </div>
                                            <p>In our example, the Share A took a 10.9% tumble over one month. If you had purchased the put
                                                warrant at MYR 0.23 when the underlying share was at MYR 9.20, you could then sell the put
                                                warrant at MYR 0.42 when the share was traded at MYR 8.20, earning a profit of 82.6%.<br /><br />
                                                If you were holding Share A, the 82.6% gain from the put warrant could be used to offset the
                                                losses you had on your shares. This strategy is known as “hedging”.</p>
                                            <table className="ctable how-call-warrant">
                                                <tbody>
                                                    <tr>
                                                        <td />
                                                        <td className="col2 htxt">Share A</td>
                                                        <td className="col3 htxt">Put Warrant A</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="col1 htxt">11 July</td>
                                                        <td className="col2">MYR 9.20</td>
                                                        <td className="col3">MYR 0.23</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="col1 htxt">11 August</td>
                                                        <td className="col2">MYR 8.20</td>
                                                        <td className="col3">MYR 0.42</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="col1 htxt">Profit/Loss</td>
                                                        <td className="col2"><b>-10.9%</b></td>
                                                        <td className="col3"><b>+82.6%</b></td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td className="disclaimer" colSpan={3}>
                                                            Note: Example is hypothetical and used here for illustration only.
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/what-are-warrant/warrant-named">
                                                How are Warrants named?
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/what-are-warrant/warrant-named">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/what-are-warrant/call-warrant-work">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        > <Link to="/edu/what-are-warrant/call-warrant-work">
                                                How a Call Warrant works
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default HowPutWarrantWorks;